import { gql } from '@apollo/client';

export default gql`
  mutation requestHSInstitution($input: requestHSInstitutionInput!) {
    requestHSInstitution(input: $input) {
      MessageId
    }
  }
`;
